


















































import { Vue, Component, Prop } from "vue-property-decorator";

// Types
import { IOrder } from "@/models/orders";
import { IMenuRoute } from "@/models/routes";

@Component({
  components: {
    "order-provider": () =>
      import("@/components/app/global/orders/orderProvider.vue"),
    "delegated-object-message": () =>
      import("@/components/app/global/delegates/delegatedObjectMsg.vue")
  }
})
export default class OrderView extends Vue {
  // Props

  @Prop({ required: true })
  public orderId!: IOrder["id"];

  @Prop({ default: () => () => [] })
  public routes!: () => IMenuRoute[];
}
